<template>
  <span class="lg-tt" :class="`p-${placement}`">
    <slot />
    <span v-if="text" class="lg-tt-bubble" role="tooltip">{{ text }}</span>
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string;
    placement?: 'top' | 'right' | 'bottom';
  }>(),
  { placement: 'top' },
);
</script>

<style scoped>
.lg-tt {
  position: relative;
  display: inline-flex;
}
.lg-tt-bubble {
  position: absolute;
  z-index: var(--lg-z-tooltip);
  pointer-events: none;
  opacity: 0;
  transform: translateY(2px);
  transition:
    opacity var(--lg-dur-fast) var(--lg-ease),
    transform var(--lg-dur-fast) var(--lg-ease);
  padding: var(--lg-space-1) var(--lg-space-2);
  border-radius: var(--lg-radius-sm);
  border: 1px solid var(--lg-border);
  background: var(--lg-bg-raised);
  color: var(--lg-text);
  font-family: var(--lg-font-sans);
  font-size: var(--lg-fs-sm);
  line-height: var(--lg-lh-tight);
  /* Bounded + wrapping so a long tooltip can't render as one 700px line that
     inflates page width on mobile (opacity:0 doesn't remove it from layout). */
  max-width: min(280px, calc(100vw - 2 * var(--lg-space-4)));
  width: max-content;
  white-space: normal;
  box-shadow: var(--lg-shadow-2);
}
.lg-tt:hover .lg-tt-bubble,
.lg-tt:focus-within .lg-tt-bubble {
  opacity: 1;
  transform: translateY(0);
}

.p-top .lg-tt-bubble {
  bottom: calc(100% + var(--lg-space-1));
  left: 50%;
  transform: translate(-50%, 2px);
}
.p-top:hover .lg-tt-bubble,
.p-top:focus-within .lg-tt-bubble {
  transform: translate(-50%, 0);
}
.p-bottom .lg-tt-bubble {
  top: calc(100% + var(--lg-space-1));
  left: 50%;
  transform: translate(-50%, -2px);
}
.p-bottom:hover .lg-tt-bubble,
.p-bottom:focus-within .lg-tt-bubble {
  transform: translate(-50%, 0);
}
.p-right .lg-tt-bubble {
  left: calc(100% + var(--lg-space-2));
  top: 50%;
  transform: translate(-2px, -50%);
}
.p-right:hover .lg-tt-bubble,
.p-right:focus-within .lg-tt-bubble {
  transform: translate(0, -50%);
}
</style>
